import { gql } from '@apollo/client'
import { BlockFragment } from 'app/features/shared/blocks'
import { GroupAdBlock } from '../blocks.types'

export const LargeGroupAdBlockFragment: BlockFragment = {
  name: 'largeGroupAd',
  fragment: gql`
    fragment largeGroupAd on LargeGroupAd {
      id
      blockType
      title
      description
      image {
        url
        alt
      }
      link
      linkText
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
  partialFragment: `
    ...on LargeGroupAd {
      id
      blockType
      title
      description
      image {
        url
        alt
      }
      link
      linkText
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const LargeGroupAdBlockType = 'largeGroupAd'

export interface LargeGroupAdBlock extends GroupAdBlock {
  blockType: typeof LargeGroupAdBlockType
  title: string
  description: string
  image: {
    url: string
    alt: string
  }
  link: string
  linkText: string
}
